import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularMaterialModule } from '@app/modules/angular-material/angular-material.module';
import { PipesModule } from '@app/pipes/pipes.module';

import { SharedUserDropdownComponent } from './shared-user-dropdown/shared-user-dropdown.component';
import { UserFilterSelectComponent } from '@app/modules/yeehro-calendly-tools/user-filter-select/user-filter-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    PipesModule
  ],
  declarations: [
    SharedUserDropdownComponent,
    UserFilterSelectComponent
  ],
  exports: [
    SharedUserDropdownComponent,
    UserFilterSelectComponent
  ]
})
export class SharedUserToolsModule { }